const DUPLICATE_CAMPAIGN_SETTINGS_TYPE = {
    ADS: 'ADS',
    BID_ADJUSTMENTS: 'BID_ADJUSTMENTS',
    SITE_BLOCKS: 'SITE_BLOCKS',
    TRACKING_CODE_THIRD_PARTY_PIXEL: 'TRACKING_CODE_THIRD_PARTY_PIXEL',
};

export default DUPLICATE_CAMPAIGN_SETTINGS_TYPE;
